module.exports = __webpack_public_path__ + "media/white-label/contact-401af35f.png";